export default "Eine kleine und schöne 1-Zimmer Wohnung, mit allem was man braucht. Es hat alles super geklappt und wir haben uns wohl gefühlt!";